import { render } from "./colorOption.vue?vue&type=template&id=58a7b496"
import script from "./colorOption.vue?vue&type=script&lang=js"
export * from "./colorOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__